module.exports = __webpack_public_path__ + "media/images/flags/sg-a4b204f8ac2f608333c244c963846403.svg";